import type { GuestStatsSample } from '../../guestStreamStatsSampler';
import type { IGuestStatsFeed } from './GuestTelemetryPorts';

function copyFrozen<T>(value: T): T {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return Object.freeze(value.map(copyFrozen)) as T;
  return Object.freeze(Object.fromEntries(Object.entries(value).map(([key, item]) => [key, copyFrozen(item)]))) as T;
}

/** Subscribers receive an immutable copy and cannot mutate production sampler state. */
export class GuestStatsFeed implements IGuestStatsFeed {
  private sample: GuestStatsSample | undefined;
  private readonly listeners = new Set<(sample: GuestStatsSample) => void>();

  latest(): GuestStatsSample | undefined { return this.sample; }
  subscribe(listener: (sample: GuestStatsSample) => void): () => void {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  }
  publish(sample: GuestStatsSample): void {
    this.sample = copyFrozen(sample);
    for (const listener of this.listeners) {
      try { listener(this.sample); } catch { /* Diagnostics never interrupt peer lifecycle. */ }
    }
  }
  reset(): void { this.sample = undefined; }
  dispose(): void { this.reset(); this.listeners.clear(); }
}
